"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearLogin = exports.isAuthenticated = exports.AuthStorage = exports.ID_TOKEN_KEY = exports.ACCESS_TOKEN_KEY = void 0;
var web_storage_1 = require("../web-storage");
exports.ACCESS_TOKEN_KEY = 'accessToken';
exports.ID_TOKEN_KEY = 'idToken';
var AuthStorage;
(function (AuthStorage) {
    AuthStorage["REMEMBERED_USERNAME"] = "rememberedUsername";
    AuthStorage["ACCESS_TOKEN"] = "accessToken";
    AuthStorage["ID_TOKEN"] = "idToken";
    AuthStorage["REFRESH_TOKEN"] = "refreshToken";
    AuthStorage["PERMISSIONS"] = "permissions";
    AuthStorage["PERSISTKEYUSER"] = "projectsLog.filters";
})(AuthStorage = exports.AuthStorage || (exports.AuthStorage = {}));
var isAuthenticated = function () {
    var accessToken = (0, web_storage_1.getLocalStorage)(AuthStorage.ACCESS_TOKEN);
    var idToken = (0, web_storage_1.getLocalStorage)(AuthStorage.ID_TOKEN);
    return accessToken !== null && idToken !== null && accessToken !== '' && idToken !== '';
};
exports.isAuthenticated = isAuthenticated;
var clearLogin = function () {
    (0, web_storage_1.deleteLocalStorage)(AuthStorage.ACCESS_TOKEN);
    (0, web_storage_1.deleteLocalStorage)(AuthStorage.ID_TOKEN);
    (0, web_storage_1.deleteLocalStorage)(AuthStorage.REFRESH_TOKEN);
    (0, web_storage_1.deleteLocalStorage)(AuthStorage.PERMISSIONS);
    (0, web_storage_1.deleteLocalStorage)(AuthStorage.PERSISTKEYUSER);
};
exports.clearLogin = clearLogin;
